import React, { FC, useEffect, useState } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Tooltip } from '@fiverr-private/tooltip';
import { InfoCircleIcon, SparkSolidIcon } from '@fiverr-private/visuals';
import {
  Collapsible,
  CollapsibleHeader,
  CollapsibleContent,
  CollapsibleHeaderChevron,
} from '@fiverr-private/disclosure';
import { UnorderedList, ListItem } from '@fiverr-private/list';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';

interface AISummaryProps {
  summary: string[];
}

export const AISummary: FC<AISummaryProps> = ({ summary }) => {
  const [shouldRenderTooltip, setShouldRenderTooltip] = useState(false);
  const { isMobile } = getContext();

  const tooltipContent = <I18n k="gig_seller_card.ai_summary.tooltip" />;

  useEffect(() => {
    // tooltips should be client side only
    setShouldRenderTooltip(true);
  }, []);

  return (
    <Container
      borderWidth="sm"
      borderColor="grey_500"
      borderRadius="2xl"
      paddingX="6"
      paddingY="3"
      backgroundColor="grey_100"
    >
      <Collapsible defaultExpanded={!isMobile}>
        <CollapsibleHeader>
          <Stack alignItems="center" gap="2" lineHeight="b_xxs">
            <SparkSolidIcon size="sm" color="purple_1100" />
            <Text as="p" fontWeight="bold" color="bodyPrimary">
              <I18n k="gig_seller_card.ai_summary.title" />
            </Text>
            {shouldRenderTooltip && (
              <Tooltip content={tooltipContent}>
                <InfoCircleIcon size="sm" color="grey_900" />
              </Tooltip>
            )}
          </Stack>
          <CollapsibleHeaderChevron />
        </CollapsibleHeader>
        <CollapsibleContent>
          <UnorderedList paddingBottom="3" paddingLeft="6" gap="1">
            {summary.map((s, index) => (
              <ListItem key={index}>
                <Text>{s}</Text>
              </ListItem>
            ))}
          </UnorderedList>
        </CollapsibleContent>
      </Collapsible>
    </Container>
  );
};
